import React, { useState, useCallback, useEffect } from 'react'
import Avatar from '@mui/material/Avatar'
import './ProfileMenuHeader.scss'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import MemberlistDialog from '../MemberlistDialog/MemberlistDialog'
import { useCMSContext } from '../../CMS/CMSContext'
import CMSActions from '../../CMS/CMSActions'
import { useGetImpersonateEnabled } from '../useGetImpersonateEnabled'
import { UserTypeEnum } from 'app/Constants/iarMemberEnum'

export const ProfileMenuHeader = React.memo((props) => {
  const { Member, setIsProfileActive } = props
  const [memberlistDialog, setMemberlistDialog] = useState(false)
  const {
    state: { appConfiguration, fireDepartment },
    actions: { setIarMember }
  } = useCMSContext()

  const isImpersonateEnabled = useGetImpersonateEnabled(appConfiguration)
  const [selectValue, setSelectValue] = useState(UserTypeEnum.Administrator)

  useEffect(() => {
    setSelectValue(Member?.userType ?? UserTypeEnum.Administrator)
  }, [Member])

  const closeMemberlistDialog = useCallback(() => {
    setMemberlistDialog(false)
    setSelectValue(Member?.userType)
  }, [Member])

  const onChangeSelect = useCallback(
    async (e) => {
      const {
        target: { textContent }
      } = e
      setSelectValue(textContent)
      if (textContent === 'Member') {
        setMemberlistDialog(true)
        setIsProfileActive(false)
      } else {
        setIsProfileActive(false)
        await CMSActions.deleteMemberImpersonationSession()
        const adminMember = await CMSActions.getIarMember()
        setIarMember(adminMember)
      }
    },
    [setIarMember, setIsProfileActive]
  )

  return (
    <div className="menu-profile">
      <nav className={`menu ${props.isMenuProfileActive ? 'active' : 'inactive'}`}>
        <ul>
          <li className="userMenu">
            <div className="avatar">
              {props.Member && props.Member.profileImage ? (
                <Avatar src={props.Member.profileImage} alt="profile"></Avatar>
              ) : (
                <div>
                  <span>{`${props.Member && props.Member.fullName ? props.Member.fullName[0] : ''}${
                    props.Member && props.Member.fullName.split(' ')[1]
                      ? props.Member.fullName.split(' ')[1][0]
                      : ''
                  }`}</span>
                </div>
              )}
            </div>
            <div className="userInfo">
              {props.Member && <div>{`${props.Member.fullName ? props.Member.fullName : ''}`}</div>}
              <div className="positionAndVersion">
                {props.Member && <div className="position">{`${props.Member.position}`}</div>}
                <div className="version">V {window._env_.REACT_APP_VERSION}</div>
              </div>
            </div>
          </li>
          {!props.Member?.isImpersonating && props.Member?.allowEditOwnProfile && (
            <li>
              <a
                href={`${window._env_.REACT_APP_LEGACY_DASHBOARD}/edit-member/${props.Member?.memberId}`}
              >
                <span>Edit my profile</span>
                <i className="icon-edit screen-guide-icon" />
              </a>
            </li>
          )}
          {(props.Member?.isImpersonating ||
            props.Member?.userType === UserTypeEnum.Administrator) &&
            isImpersonateEnabled && (
              <li id="viewAsContainer">
                <span id="viewAs">View as</span>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={selectValue}
                  IconComponent={() => <ArrowDropDownIcon className="viewAsIcon" />}
                  sx={{
                    '& fieldset': { border: 'none' },
                    '&.Mui-focused fieldset': { border: 'solid' }
                  }}
                >
                  <MenuItem value={UserTypeEnum.Administrator} onClick={(e) => onChangeSelect(e)}>
                    Administrator
                  </MenuItem>
                  <MenuItem value={UserTypeEnum.Member} onClick={(e) => onChangeSelect(e)}>
                    Member
                  </MenuItem>
                </Select>
              </li>
            )}
          {fireDepartment && (
            <MemberlistDialog
              open={memberlistDialog}
              onClose={closeMemberlistDialog}
              fireDepartmentId={fireDepartment.fireDepartmentId}
              setMemberlistDialog={setMemberlistDialog}
              setIarMember={setIarMember}
            />
          )}
        </ul>
      </nav>
    </div>
  )
})

export default ProfileMenuHeader
